export enum ViewportThemes {
  LIGHT = 'light',
  DARK = 'dark',
}
